export const PARTNER_METRICS = "PartnerMetrics";
export const BUSINESS_EXPANSION = "BusinessExpansion";
export const COSELLING = "CoSelling";
export const FOUNDATION = "Foundation";
export const MARKETING = "Marketing";
export const PARTNER_GOALS = "PartnerGoals";
export const PARTNER_OPPORTUNITIES = "PartnerOpportunities";
export const PARTNER_PLANNING = "PartnerPlanning";
export const SALES_AND_TECHNICAL_ENABLEMENT = "SalesAndTechnicalEnablement";
